/**
 * The Cash coin — the "c" mark, given a body.
 *
 * Janeks: *"generate Coin logo - use the existing c but give it a background
 * and spin it on hover."* The face is a Higgsfield-generated worn steel coin
 * (/public/clutter/coin.webp); the glyph is TEXT on top of it, so it stays
 * crisp at any size and is the same "c" the wallet always showed. The spin and
 * the rim live in CSS (`styles/coin.css.ts`). Decorative: the number beside it
 * is the information.
 */
export type CoinSize = 'sm' | 'md' | 'lg';

/** Cash glyph. The wallet has always drawn the cent sign. */
export const CASH_GLYPH = '¢';

export function cashCoinHtml(size: CoinSize = 'md'): string {
  return `<span class="bv-ccoin bv-ccoin-${size}" aria-hidden="true"><span class="bv-ccoin-face">${CASH_GLYPH}</span></span>`;
}
